import { render, staticRenderFns } from "./ActUploads__modalTax.vue?vue&type=template&id=43b9b190&scoped=true&"
import script from "./ActUploads__modalTax.vue?vue&type=script&lang=js&"
export * from "./ActUploads__modalTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b9b190",
  null
  
)

export default component.exports